<div
	class="page-wrapper"
	appScrollListener
	(scrolled)="onContainerScroll($event)"
	#scrollableContainer="appScrollListener"
>
	@if(toTopButtonVisible){
	<a class="scroll-up-button" (click)="scrollToTop(scrollableContainer)" aria-label="To top" title="Go to top">
		<i class="fa fa-arrow-up" aria-hidden="true"></i>
	</a>
	}
	<div class="top-section">
		<div class="search-and-table-mode-switcher">
			<div class="control-input-with-button">
				<div class="control-input-container search-box">
					<div class="input-box">
						<input
							name="searchText"
							type="text"
							class="control-input"
							[(ngModel)]="searchText"
							placeholder="Order ID..."
						/>
					</div>
				</div>
				<button class="btn btn-primary action-button" (click)="searchOrderById()">Search</button>
			</div>
		</div>

		@if(salesStatus !== 'returns'){
		<div class="control-input-container">
			<label for="filterStatus">QC Status</label>
			<div class="input-box">
				<select
					class="control-input"
					id="filterStatus"
					name="status"
					[(ngModel)]="status"
					(change)="filterStatus()"
				>
					<option selected value="ready">Ready for QC</option>
					<option value="shipping">Shipping | Submitted for QC</option>
					<option value="shippingQc">Shipping QC | Processing</option>
					<option value="completed">Completed</option>
				</select>
			</div>
		</div>
		} @if(salesStatus !== 'returns'){
		<button class="btn btn-secondary refresh-button" (click)="filterStatus()" type="button">
			<i class="mdi mdi-refresh"></i>
		</button>
		}
	</div>

	<div class="middle-section">
		@if(data.isShopify){
		<div class="custom-radio-group">
			<label class="custom-radio" [ngClass]="{ selected: salesStatus === 'regular' }">
				<input
					type="radio"
					name="salesStatus"
					[(ngModel)]="salesStatus"
					[value]="'regular'"
					(change)="filterSalesStatus()"
				/>
				<span class="radio-circle"></span>
				<span class="radio-label">Orders</span>
			</label>

			<label class="custom-radio" [ngClass]="{ selected: salesStatus === 'returns' }">
				<input
					type="radio"
					name="salesStatus"
					[(ngModel)]="salesStatus"
					[value]="'returns'"
					(change)="filterSalesStatus()"
				/>
				<span class="radio-circle"></span>
				<span class="radio-label">Returns</span>
			</label>
		</div>
		} @if(salesStatus !== 'returns'){
		<div class="control-input-with-button">
			<div class="control-input-container">
				<label for="bulkActions">Bulk actions</label>
				<div class="input-box">
					<select name="action" id="bulkActions" [(ngModel)]="action" class="control-input">
						<option value="" disabled selected hidden>Select your option</option>
						<option *ngIf="status === 'ready'" value="submitAndPrint">Submit for QC / Picksheet PDF</option>
						<option *ngIf="!(status === 'ready')" value="print">Download Picksheet PDF</option>
						<option *ngIf="status === 'ready'" value="submit">Submit for QC only</option>
					</select>
				</div>
			</div>
			<button
				type="button"
				[disabled]="!action || countOfCheckedOrders == 0"
				class="btn btn-primary action-button"
				(click)="bulkAction()"
			>
				Confirm
			</button>
		</div>

		}
	</div>

	<div class="table-wrapper">
		@if(salesStatus !== 'returns'){
		<div class="selected-items-count">
			<span>{{ countOfCheckedOrders }} Selected</span>
		</div>
		}
		<div class="table-scroller">
			@if(!loading){
			<table>
				<thead>
					<tr>
						<th style="width: 120px">Order</th>
						<th style="width: 240px">Date</th>
						<th>Customer</th>
						<th class="table-text-center">Items</th>
						<th class="table-text-center">Order Status/QC Status</th>
						<th></th>
						<th *ngIf="!(salesStatus === 'returns')" class="table-text-end">
							<input name="allSelected" type="checkbox" [ngModel]="allSelected" (click)="selectAll()" />
						</th>
						<th *ngIf="salesStatus === 'returns'" class="table-text-center">
							<span>Print Products</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let order of orders; let ind = index" ng-class="order.class">
						<td>
							<a href="{{ order.link }}" target="_blank" style="text-decoration: none">{{
								order.Data.Name
							}}</a>
						</td>
						<td>{{ order.Data.OrderDate | date : 'medium' : '' : data.locale }}</td>
						<td>{{ order.Data.CustomerName }}</td>
						<td class="cursor-pointer table-text-center" (click)="openProductsInfoModal(order.Data)">
							{{ order.Data.ItemsTotal }} item
						</td>
						<td class="table-text-center">{{ order.Data.Status }}</td>
						<td>
							{{ order.Data.Printed }}
							<a
								class="has-notify-icon-small"
								[ngClass]="{ printed: order.Data.PrintStatus === 'Printed' }"
								title="Printed"
							></a>
						</td>
						<td *ngIf="!(salesStatus === 'returns')" class="table-text-end">
							<input
								name="order[{{ ind }}].Selected"
								type="checkbox"
								[(ngModel)]="order.Data.Selected"
								(click)="toggleSelected(ind, $event)"
							/>
						</td>
						<td *ngIf="salesStatus === 'returns'" class="table-text-center">
							<button
								type="submit"
								class="btn btn-info simpleRfIdColor"
								(click)="copyAndPrint(order.Data.Items)"
								[disabled]="!isPrintingEnable"
								[ngbTooltip]="isPrintingEnableTitle"
								[openDelay]="300"
								[closeDelay]="300"
							>
								Print
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			} @else {
			<div class="page-loader">
				<div class="loader"></div>
			</div>
			}
		</div>
	</div>
</div>

<div *ngIf="showPopUp" id="popUpOverlay">
	<div class="popUpContent" style="text-align: left">
		<h3 class="table-text-center" style="font-weight: bold">{{ popUpTitle }}</h3>
		<hr />
		To submit the order(s) please specify SKU for the following product(s):
		<div *ngFor="let e of errors">
			Order {{ e.Name }}:
			<div *ngFor="let product of e.Error; let i = index">
				<a target="_blank" href="{{ product.addSkuUrls }}">{{ i + 1 }}. {{ product.CombinedName }}</a>
			</div>
			<br />
		</div>
		<hr />
		<div class="center">
			<button class="btn btn-sm btn-info" style="background-color: rgb(84, 143, 214)" (click)="closePopUp()">
				Ok
			</button>
		</div>
	</div>
</div>
